import spartaStoreUtility from "utilities/global/sparta-store-utility/3.0.3/js/sparta-store-utility";






class SpartaRequireUtility {

  constructor() {
    this.resourceLoadListeners = new Map();
    this._dynamicModulePromiseCache = new Map();    
  }

  get dynamicModulePromiseCache(){
    return this._dynamicModulePromiseCache;
  }

  set dynamicModulePromiseCache(moduleCache){
    this._dynamicModulePromiseCache = moduleCache;
  }






  registerResourceLoadListener(resourceUrl, callback) {
    this.resourceLoadListeners.set(resourceUrl, callback);
  }





  unRegisterResourceLoadListener(resourceUrl) {
    this.resourceLoadListeners.delete(resourceUrl);
  }






  getRequirePromise(urls) {
    return new Promise((resolve, reject) => {
      this.getRequire()(urls, resolve, reject);
    });
  }













  getResourceWithDependencies(url) {
    let dynamicModulePromise = this._dynamicModulePromiseCache.get(url);
    if (dynamicModulePromise) {
      return dynamicModulePromise;
    }

    this.setOnResourceLoad(this.resourceLoadListeners);  

    dynamicModulePromise = new Promise(async (resolve, reject) => {
      try {
        this.registerResourceLoadListener(url, function (context, map, depArray) {
          if (url === map.id) {
            resolve({ context, map, depArray });
          }
        });
        const requireJs = this.getRequire();
        try {


          requireJs.s.contexts._.defined[url] && requireJs.undef(url);
        } catch (error) {
          console.log(`Error in requirejs.undef(${url})`, error);
        }
        await this.getRequirePromise([url]);
      } catch (error) {
        reject(error);
      } finally {
        this.unRegisterResourceLoadListener(url);
      }
    });
    this._dynamicModulePromiseCache.set(url, dynamicModulePromise);
    return dynamicModulePromise;
  }


  getRequire() {
    const widgetContext = spartaStoreUtility.getData('applicationContext');
    let requireJs;

    if (widgetContext) {
      const widgetVersion = window.sparta.require[widgetContext.name][widgetContext.version];
      requireJs = (widgetContext.id) ? widgetVersion[widgetContext.id].require : widgetVersion.require;
    } else if (window.require){
      requireJs = window.require;
    } else if(window.sparta && window.sparta.require) {
      requireJs = window.sparta.require;
      console.warn('fallback to window.sparta.require since window.require is undefined');
    } else {
      console.warn('requirejs is undefined');
    } 

    return requireJs;
  }





  setOnResourceLoad(resourceLoadListeners) {
    const requireJs = this.getRequire();
    if (requireJs && !requireJs.onResourceLoad) {
      requireJs.onResourceLoad = function (context, map, depArray) {
        const callback = map && map.id && resourceLoadListeners.get(map.id);
        callback && callback(context, map, depArray);
      }
    }
  }

}

export default new SpartaRequireUtility();